// removed by extract-text-webpack-plugin
module.exports = {"line":"_1U3vYGfPBpfqW7N7HlP-Sb","title":"_1HCNliRf41W1UTPzv-cnv1","labelBox":"_1veP-EdRts47SRU91vzdKi","label":"_2XMSYkREhXJRpUooOok5QN","icon":"_3HiURyW0AJHhABeiZV7GKS","dec":"_1dE1WSwthbKls2m_C-Unli","moreButtonBox":"_3hsX7RDi21-v4629Ht6L-T","more":"_1Xg4LbljeDtYm86PBcA091","moreArrow":"_3LgIe34RTBWiAPVEKr8eqR","moreDec":"_1I6yQNtl1KhgC8m1qW7K7v","moreBox":"_2TkXF-OsfptvQfFogG-Q5l","show":"_3T2hKHCwrl4OsxMd1hDF92"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/CompareScenes/Compare.module.less
// module id = 793
// module chunks = 0